import { inject, Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CargaService } from '@/app/services/carga.service';
import { PdfService } from '@/app/services/pdf.service';
import { TokenReaderService } from '@/app/services/security/token-reader.service';
import Swal from 'sweetalert2';
import { EnviarCargaComponent } from '@/app/components/cargas/enviar-carga/enviar-carga.component';

@Component({
    selector: 'app-detalles-carga',
    templateUrl: './detalles-carga.component.html',
    styleUrls: ['./detalles-carga.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DetallesCargaComponent {

  private spinner = inject(NgxSpinnerService);

  //validaciones
  isValid: boolean = false;
  isEdit: boolean = false;

  seReenvio: boolean = false;
  responseReenvio: boolean = false;
  noDetalles: boolean = false;
  msgEnvio: string = "Aprobar Envío";

    //finalizacion de operacion
    hasFinished: boolean = false;

  //modelo
  cargaRQ = {
    numeroActivo: '', //detalles,pdf,
    IATA: '', //editar
    idCarga: 0, //editar, 
    clave: '', 
    descripcion: '', //detalles,
    fechaCreacion: new Date(), //detalles,,pdf
    horometroAnterior: 0, //editar
    horometro: 0, //editar, 
    litrosCargaAnterior: 0, //editar
    litrosCarga: 0, //editar, 
    combustibleCargado: '',  //detalles,pdf,
    idEstatus: null,
    observacionesAnterior: '', // editar
    observaciones: '', //detalles - editar
    nombreOperador: '', //detalles
    numeroDespachador: 0, //detalles, 
    nombreDespachador: '', //detalles
    numeroOperador: 0, //detalles, 
    almacen: '', //detalles, 
    idEquipo: null,
    idAlmacen: null,
    idEstacion: null, //editar
    estatus: '', //detalles
    fechaCarga: new Date(),
    pathFoto: '', //detalles
    creadoPor: 0,
    fechaModificacion: new Date(),
    modificadoPor: 0, //editar
    fechaEnvioMaximo: new Date(),
    idOperador: 0,
    transaccionMaximo: 0, //detalles
    cargaEstacion: '', //pdf
    idDespachador: 0,
    fechaEnvioApi: new Date(),
    nombre: '', //editar
    Justificacion: '',
  }

  constructor(
    private cargaService: CargaService,
    private toastr: ToastrService,
    private router: Router,
    public dialogRef: MatDialogRef<DetallesCargaComponent>,
    private pdfService: PdfService,
    private userTokenReader: TokenReaderService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ){
    this.isValid = this.userTokenReader.isValid();

    //console.log(data);
    let {idCarga} = data;
    this.getCarga(idCarga);
  }

  // Devuelve el src correcto para la imagen: si pathFoto ya es una URL
  // (p. ej. URL firmada de S3) se usa tal cual; si es base64 se le antepone el prefijo data URI.
  getImageSrc(pathFoto: string): string {
    if (!pathFoto) {
      return '';
    }
    const value = pathFoto.trim();
    if (/^https?:\/\//i.test(value) || value.startsWith('data:')) {
      return value;
    }
    return 'data:image/jpg;base64,' + value;
  }

  getCarga(idCarga: number){
    this.spinner.show();
    this.cargaService.getLoadDetail(idCarga).subscribe({
      next: (data: any) => {
        this.cargaRQ.idCarga = data.Carga.idCarga;
        this.cargaRQ.nombreDespachador = data.Carga.nombreDespachador;    
        this.cargaRQ.idDespachador = data.Carga.idDespachador;
        this.cargaRQ.numeroDespachador=data.Carga.numeroDespachador;
        this.cargaRQ.nombreOperador = data.Carga.nombreOperador;    
        this.cargaRQ.idOperador = data.Carga.idOperador;
        this.cargaRQ.numeroOperador=data.Carga.numeroOperador;   
        this.cargaRQ.descripcion = data.Carga.descripcion;   
        this.cargaRQ.fechaCreacion = data.Carga.fechaCreacion;
        this.cargaRQ.pathFoto = data.Carga.pathFoto;
        this.cargaRQ.transaccionMaximo = data.Carga.transaccionMaximo ==null ? 0 : data.Carga.transaccionMaximo;
        this.cargaRQ.fechaEnvioMaximo = data.Carga.fechaEnvioMaximo;
        this.cargaRQ.fechaModificacion = data.Carga.fechaModificacion;
        this.cargaRQ.almacen = data.Carga.almacen;
        this.cargaRQ.estatus = data.Carga.estatus;

        //nos sirve para regresar los valores antes de la modificación
        this.cargaRQ.horometroAnterior = data.Carga.horometro;
        this.cargaRQ.litrosCargaAnterior = data.Carga.litrosCarga;
        this.cargaRQ.observacionesAnterior = data.Carga.observaciones == '' ? 'N/A': data.Carga.observaciones;

        //
        this.cargaRQ.horometro = data.Carga.horometro;
        this.cargaRQ.litrosCarga = data.Carga.litrosCarga;
        this.cargaRQ.observaciones = data.Carga.observaciones == '' ? 'N/A': data.Carga.observaciones;
        this.cargaRQ.IATA = data.Carga.IATA;

        this.cargaRQ.cargaEstacion = data.Carga.cargaEstacion;
        this.cargaRQ.combustibleCargado = data.Carga.combustibleCargado;
        this.cargaRQ.numeroActivo = data.Carga.numeroActivo;
        this.cargaRQ.idEquipo = data.Carga.idEquipo;

        this.cargaRQ.Justificacion = data.Carga.justificacion != null ? data.Carga.justificacion : '';
        this.seReenvio = data.Carga.flagReenvio === 1 ? true : false;

        if(this.cargaRQ.estatus === 'Enviado' || this.cargaRQ.estatus === 'Cancelado' || this.cargaRQ.estatus === 'Entregado' 
          || this.cargaRQ.estatus === 'Aprobado'){
          this.noDetalles = true;
          this.msgEnvio = 'Detalles de Envío';
        }
        

        this.spinner.hide();
      },
      error: (err) => {
        this.spinner.hide();
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          if(err.error){
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      }
    });
  }
  
  //boton - cancelar 
  cancelLoad(idCarga: number){
    this.spinner.show();
    this.cargaService.cancelLoad(idCarga, this.userTokenReader.getUserData().idUsuario).subscribe({
      next: (data: any) => {
        this.spinner.hide();
        Swal.fire(
          'Éxito',
          'Carga cancelada.',
          'success'
        ).then(result=>{
          this.hasFinished = true;
          this.onClose();

        });
      },
      error: (err) => {
        this.spinner.hide();
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          if(err.error){
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      }
    });
  }

  
  //botón - pdf
   exportPDF(carga: any) {
    this.spinner.show();
    this.pdfService.createPDF(carga);
  }


  //boton - editar
  controlEditCarga(form: NgForm){
    this.isEdit = !this.isEdit;
    if(!this.isEdit && !form.pristine){
        this.cargaRQ.horometro = this.cargaRQ.horometroAnterior;
        this.cargaRQ.litrosCarga = this.cargaRQ.litrosCargaAnterior;
        this.cargaRQ.observaciones = this.cargaRQ.observacionesAnterior;
    }
  }

  
  formSubmitEdit(form:NgForm){
    if(form.valid){
      Swal.fire({
        title: 'Confirmar',
        text: "¿Deseas actualizar esta carga?",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#1c869e ',
        cancelButtonColor:  '#999999',
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Regresar',
        allowOutsideClick: true,
        reverseButtons: true
      }).then((result) => { 
        if(result.value){
          this.saveEditCarga();
        }
      });
    }
  }
  saveEditCarga(){
    var cargaUpdateRQ = {
      idCarga: this.cargaRQ.idCarga,
      litrosCarga: this.cargaRQ.litrosCarga,
      horometro: this.cargaRQ.horometro,
      observaciones: this.cargaRQ.observaciones.trim(),
      idEstacion: this.cargaRQ.IATA,
      nombre: this.userTokenReader.getUserData().apellidoPaterno+' '+this.userTokenReader.getUserData().apellidoMaterno+' '+this.userTokenReader.getUserData().nombre,
      modificadoPor: this.userTokenReader.getUserData().idUsuario,
    }
    this.spinner.show();
    this.cargaService.updateLoad(cargaUpdateRQ).subscribe({
      next: (data: any) => {
        this.spinner.hide();
        Swal.fire(
          'Éxito',
          'Carga actualizada correctamente.',
          'success'
        ).then(result=>{
          this.isEdit = false;
          this.getCarga(this.cargaRQ.idCarga);
        });
      },
      error: (err) => {
        this.spinner.hide();
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          if(err.error){
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      }
    });
  }

  //para abrir modal de enviar carga
  abrirModalEnviarCarga(){
    const dialogRef = this.dialog.open(EnviarCargaComponent, {
      width: '550px',
      height: '460px',
      data: { idCarga: this.cargaRQ.idCarga, isValid: this.noDetalles, idEstatus: this.cargaRQ.estatus, 
       seReenvio: this.seReenvio, justificacion: this.cargaRQ.Justificacion },
      panelClass: 'custom-dialog-container',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.updateList) {
        if(result.seReenvio){
          this.responseReenvio = true;
        }
        this.hasFinished = true;
        this.onClose();
      } 
    });

    this.router.events.subscribe(() => {
      dialogRef.close();
    });
  }


  //para cerrar modal
  onClose(){
    if(!this.hasFinished && !this.noDetalles){
      Swal.fire({
        title: 'Alerta',
        text: "No se ha realizado ninguna operación. ¿Seguro que deseas salir?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#999999',
        cancelButtonColor:  '#1c869e',
        confirmButtonText: 'Salir',
        cancelButtonText: 'No salir',
        allowOutsideClick: false,
        reverseButtons: false
      }).then((result) => {
        if(result.value){
          this.dialogRef.close({updateList: false});
        }
      });
    } else{
      if(!this.noDetalles || this.responseReenvio){
        this.dialogRef.close({updateList: true});
      }else{
        this.dialogRef.close({updateList: false});
      }
    }
  }
}
